export default "__VITE_ASSET__pQUWRfHv__"